module.exports = __webpack_public_path__ + "img/about_us_1.45b90475.png";